module.exports = __webpack_public_path__ + "img/modulo_HTML.7b3ddf9.svg";